import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';
import { RootState, AuthState } from 'model/state';
import { Account, User } from 'model';
import { keyBy } from 'lodash';

/**
 * Direct selector to the account state
 */
const selectAuth = () => (state: RootState) => state.auth;

/**
 * Other specific selectors
 */
const selectUserId = () => createSelector(
    selectAuth(),
    (auth: AuthState) => auth.userId
);

const selectIsAuthenticated = () => createSelector(
  selectAuth(),
  (auth: AuthState) => !isEmpty(auth.token)
);

const selectIsAuthSubmitting = () => createSelector(
  selectAuth(),
  (auth: AuthState) => auth.isSubmitting
);

const selectLoggedUser = () => createSelector(
  selectAuth(),
  (auth: AuthState) => auth.user
);

const selectAccount = () => createSelector(
  selectAuth(),
  (auth: AuthState) => auth.user?.account
)

const selectAccountId = () => createSelector(
  selectAccount(),
  (account: Account | undefined) => account?.id
)

const selectIsFetching = () => createSelector(
  selectAuth(),
  (auth: AuthState) => auth.isFetching
);

const selectInvitationData = () => createSelector(
  selectAuth(),
  (auth: AuthState) => auth.invitationData
);

const selectVerifiedOK = () => createSelector(
  selectAuth(),
  (auth: AuthState) => auth.verifiedOK
);

const selectUserLocale = () => createSelector(
  selectAuth(),
  (auth: AuthState) => auth.user?.locale
);

const selectUserUnitSystem = () => createSelector(
  selectAuth(),
  (auth: AuthState) => auth.user?.unitSystem
);

const selectLoggedUserLocationRolesMap = () => createSelector(
  selectLoggedUser(),
  (user?: User) => {
    return keyBy(user?.locationRoles || [], roles => roles.locationId);
  }
);

const selectResetPasswordToken = () => createSelector(
  selectAuth(),
  (auth: AuthState) => auth.resetPasswordToken
);

export default selectAuth;
export {
  selectUserId,
  selectIsAuthenticated,
  selectIsAuthSubmitting,
  selectLoggedUser,
  selectAccount,
  selectAccountId,
  selectIsFetching,
  selectInvitationData,
  selectVerifiedOK,
  selectUserLocale,
  selectUserUnitSystem,
  selectLoggedUserLocationRolesMap,
  selectResetPasswordToken,
}